import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Popup, Button } from 'semantic-ui-react'

export const ConfirmDeletePopup = ({
  loading,
  onDelete,
  trigger,
  header,
  content,
  buttonText,
  position,
}) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleDelete = () => {
    setIsOpen(false)
    onDelete()
  }

  return (
    <Popup
      basic
      trigger={trigger}
      position={position || 'bottom left'}
      on="click"
      flowing
      open={isOpen}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
      hideOnScroll
    >
      <Popup.Header>{header}</Popup.Header>
      <Popup.Content>
        {content}
        <Button
          negative
          fluid
          className="mt2"
          loading={loading}
          disabled={loading}
          onClick={handleDelete}
        >
          {buttonText}
        </Button>
      </Popup.Content>
    </Popup>
  )
}
ConfirmDeletePopup.propTypes = {
  onDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  trigger: PropTypes.node,
  header: PropTypes.node,
  content: PropTypes.node,
  buttonText: PropTypes.string,
  position: PropTypes.string,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/ConfirmDeletePopup/index.js